import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import useDisplay from "../../../hooks/useDisplay";
import LSRgH2HeadLine from "../../molecules/text/linSeedKr/Rg/lsRgH2HeadLine";
import LSBdDisplay02 from "../../molecules/text/linSeedKr/Bd/lsBdDisplay02";
import LSRgDisplay02 from "../../molecules/text/linSeedKr/Rg/lsRgDisplay02";
import LSRgBody01 from "../../molecules/text/linSeedKr/Rg/lsRgBody01";
import { fileUrl } from "../../../api/api";
import moment from "moment";
import { route } from "../../../router/route";

function ReviewItem({ data }) {
  const navigate = useNavigate();
  const { isMobile, isTablet, isDesktop } = useDisplay();

  return (
    <>
      <div
        onClick={() => {
          if (!data.lecture?.id) return;
          if (data.lectureVideoFlag) {
            navigate(`${route.lecture_detail}/${data.lecture.id}`, {
              state: { isReviewIn: true },
            });
          } else {
            navigate(`${route.consulting_detail}/${data.lecture.id}`, {
              state: { isReviewIn: true },
            });
          }
        }}
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          minWidth: isMobile ? 200 : 380,
          height: isMobile ? 267 : 422,
          position: "relative",
          background: "#F4FAFF",
          cursor: "pointer",
          borderRadius: 15,
          padding: isMobile ? "20px" : "48px 40px",
          marginRight: isMobile ? 15 : isTablet ? 30 : 0,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            marginBottom: 16,
          }}
        >
          <img
            style={{
              width: isMobile ? 12 : 24,
              height: isMobile ? 12 : 24,
              marginRight: isMobile ? 4 : 8,
              marginBottom: isMobile ? 2 : 4,
            }}
            src={"/assets/icons/star_3d.png"}
            alt="star_3d"
          />
          <LSBdDisplay02
            style={{
              color: "#101113",
              fontSize: isMobile ? 14 : 24,
              lineHeight: isMobile ? "19.6px" : "33.6px",
            }}
          >
            {Number(data.score ?? 0).toFixed(1)}
          </LSBdDisplay02>
        </div>

        <ReviewTitle
          style={{
            fontSize: isMobile ? 16 : 24,
            lineHeight: isMobile ? "22.4px" : "33.6px",
            color: "#101113",
            marginBottom: 20,
            height: isMobile ? 44 : 68,
          }}
        >
          {data.title}
        </ReviewTitle>

        <ReviewContent
          $isMobile={isMobile}
          style={{
            color: "#101113",
            fontSize: isMobile ? 14 : 18,
            lineHeight: isMobile ? "19.6px" : "25.2px",
          }}
        >
          {data.content}
        </ReviewContent>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <img
            style={{
              width: isMobile ? 24 : 56,
              height: isMobile ? 24 : 56,
              marginRight: isMobile ? 8 : 24,
              borderRadius: 999,
            }}
            src={
              data.member?.profileServerFileName
                ? `${fileUrl}/${data.member?.profileServerFileName}`
                : "/assets/icons/profile.png"
            }
            alt="profile"
          />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <LSRgH2HeadLine
              style={{
                color: "#898E99",
                fontSize: isMobile ? 12 : 18,
                lineHeight: isMobile ? "14.4px" : "25.2px",
              }}
            >
              {data.member?.nickname ?? "탈퇴한 회원"}
            </LSRgH2HeadLine>
            <LSRgBody01
              style={{
                color: "#898E99",
                marginTop: 5,
                fontSize: isMobile ? 10 : 14,
                lineHeight: isMobile ? "12px" : "19.6px",
              }}
            >
              {moment(data.createdAt).format("YYYY.MM.DD")}
            </LSRgBody01>
          </div>
        </div>
      </div>
    </>
  );
}

export default ReviewItem;

const ReviewContent = styled(LSRgH2HeadLine)`
  color: #101113;
  margin-bottom: ${(props) => (props.$isMobile ? "16px" : "32px")};

  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-word;

  display: -webkit-box;
  -webkit-line-clamp: 4; // 원하는 라인수
  -webkit-box-orient: vertical;
`;

const ReviewTitle = styled(LSRgH2HeadLine)`
  font-size: 24px;
  line-height: 33.6px;
  color: rgb(16, 17, 19);
  margin-bottom: 20px;
  height: 68px;

  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-word;

  display: -webkit-box;
  -webkit-line-clamp: 2; // 원하는 라인수
  -webkit-box-orient: vertical;
`;
